import React, { FC, useRef } from 'react'

import { Image as RawImage, ImageProps } from '@sketch/components'
import { useAnalytics } from '../../analytics'

/**
 * Wrapper for Image component that triggers an ananlytics event when the
 * component loads.
 */
export const Image: FC<ImageProps> = props => {
  const { pageLoad } = useAnalytics()
  const ref = useRef<HTMLImageElement>(null)

  const handleImageLoad = (event: Event) => {
    props.onLoad?.(event)

    ref.current &&
      pageLoad.observeCustomElement({
        element: ref.current,
        identifier: 'image',
      })
  }

  return <RawImage ref={ref} {...props} onLoad={handleImageLoad} />
}
